export default __webpack_public_path__ + "static/media/nariko.1a442dd6.png";